/**
 * Which tier this build talks to, and how it should look.
 *
 * Every API base URL is resolved here from build-time env vars rather than
 * being module constants with the alternatives commented out beside them. That
 * pattern is why the production dashboard shipped pointing at
 * teleservices-dev, and why a dev build could not reach the -dev backends at
 * all.
 *
 * Values come from .env.production / .env.dev / .env.development, plus
 * .env.development.local which the meta-repo launcher writes and git ignores.
 */

const required = (key) => {
  const value = process.env[key];
  if (!value) {
    throw new Error(
      `[environment] ${key} is not set. Check the .env file for mode "${process.env.NODE_ENV}".`,
    );
  }
  return value;
};

/** "prod" | "dev" | "local" - drives the colour scheme and the banner. */
export const ENVIRONMENT = required("VUE_APP_ENVIRONMENT");

if (!["prod", "dev", "local"].includes(ENVIRONMENT)) {
  throw new Error(
    `[environment] VUE_APP_ENVIRONMENT must be prod, dev or local (got "${ENVIRONMENT}")`,
  );
}

export const IS_PRODUCTION = ENVIRONMENT === "prod";

export const ENDPOINTS = {
  main: required("VUE_APP_API_MAIN"),
  auth: required("VUE_APP_API_AUTH"),
  reports: required("VUE_APP_API_REPORT"),
  teleservices: required("VUE_APP_API_TELESERVICES"),
  // EuroForMix is one service shared by both tiers - it holds no laboratory
  // data of its own, so there is no -dev copy to point at.
  euroformix: required("VUE_APP_API_EUROFORMIX"),
  // The scanner bridge (drivers.lims.ninja) and the label printer run on the
  // operator's own machine in every environment, so they stay local.
  scan: process.env.VUE_APP_API_SCAN || "http://localhost:8000",
  printing: process.env.VUE_APP_API_PRINTING || "http://localhost:3540",
};

/** Shown in the banner. Deliberately loud for anything that is not production. */
export const ENVIRONMENT_LABEL = {
  prod: "",
  dev: "DEV — test environment, not real data",
  local: "LOCAL — running against local services",
}[ENVIRONMENT];

if (!IS_PRODUCTION) {
  // eslint-disable-next-line no-console
  console.info(`[environment] ${ENVIRONMENT}`, ENDPOINTS);
}
